import gql from 'graphql-tag';

export const CommentDetails = gql`
  fragment CommentDetails on AccountFileComment {
    id
    message
    created_at
    account {
      id
      name
      username
      avatar_photo {
        id
        thumbnail_urls {
          size_code
          url
        }
      }
    }
    photo {
      id
    }
    video {
      id
    }
    parent {
      id
    }
    children {
      total
    }
  }
`;
